export function loadInitialPaging(scrollToContent) {
    var pageCount = $("#hdnPageCount").val();
    var pagingHtml = "";
    for (var i = 1; i <= pageCount && i < 6; i++) {
        if (i == 1) {
            pagingHtml += "<span id='paging-" + i + "' class='apa-page active' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + i + "</span>";
        } else {
            pagingHtml += "<span id='paging-" + i + "' class='apa-page' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + i + "</span>";
        }
    }
    if (pageCount <= 1) {
        $(".apa-paging").hide();
    } else {
        $(".apa-paging").show();
    }
    $(".apa-page-list").html(pagingHtml);

    if (scrollToContent == true) {
        $('html,body').animate({
            scrollTop: $(".all-articles").offset().top
        }, 'fast');
    }
}

export function loadRelatedArticlePage(pageControl, lastPageNumber) {
    var pageCount = parseInt($("#hdnPageCount").val(), 10) || 0;
    if (pageCount < 1) {
        return;
    }
    if (pageControl.hasClass("apa-first-page")) { // [ << ]
        var newControl = $(".apa-paging #paging-" + ("1"));
        loadArticlePage(null, 1);
    }
    else if (pageControl.hasClass("apa-last-page")) {    // [ >> ]
        var newControl = $(".apa-paging .apa-page:nth-last-child(2)");
        loadArticlePage(null, pageCount);
    }
    else if (pageControl.hasClass("apa-prev-page")) {    // [ < ]
        var pageNumber = parseInt($(".apa-paging .apa-page.active").html());
        if (pageNumber > 1) {
            var newControl = $(".apa-paging #paging-" + (pageNumber - 1));
            $(".apa-paging .apa-page.active").removeClass('active');
            $(".apa-paging #paging-" + (pageNumber - 1)).addClass('active');
            loadArticlePage(newControl);
        }
    }
    else if (pageControl.hasClass("apa-next-page")) {    // [ > ]
        var pageNumber = parseInt($(".apa-paging .apa-page.active").html());
        if (pageNumber < pageCount) {
                var newControl = $(".apa-paging #paging-" + (pageNumber + 1));
                $(".apa-paging .apa-page.active").removeClass('active');
                $(".apa-paging #paging-" + (pageNumber + 1)).addClass('active');
                loadArticlePage(newControl);
        }
    }
}

export function getParameterByName(name, fallbackValue) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.href);
    return results === null ? fallbackValue : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function loadArticlePage(pageControl, pageNumber) {
    var pageCount = parseInt($("#hdnPageCount").val(), 10) || 0;
    var currentPage;
    if (typeof(pageNumber) != "undefined" && pageNumber != null) {
        currentPage = pageNumber;
    }
    else if (pageControl && pageControl.length) {
        currentPage = pageControl.html();
    }

    // Guard against a missing/invalid target page so we never render "NaN" / "undefined" page numbers.
    currentPage = parseInt(currentPage, 10);
    if (isNaN(currentPage) || currentPage < 1) {
        return;
    }

    var paramCategoryId = getParameterByName("categoryId", 0);

    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host;
    $.ajax({
        type: "POST",
        url: baseUrl + "/AlliedPilots/Articles/ViewArticlesByPage",
        data: {
            pageNumber: currentPage,
            categoryId: paramCategoryId
        },
        success: function (response) {
            window.history.replaceState(null, null, '?categoryId=' + paramCategoryId + '&pageNumber=' + currentPage);
            $("#articles-container").html(response);
            $('html,body').animate({
                scrollTop: $(".all-articles").offset().top
            }, 'fast');
        },
        error: function (data) {
        }
    });
    ////show/hide the nearby paging controls
    if (currentPage == 1) {
        var htmlPageNumber = "";
        htmlPageNumber += "<span class='apa-page active' id='paging-" + "1" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>1</span>";
        if (pageCount >= 2) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "2" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>2</span>";
        }
        if (pageCount >= 3) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "3" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>3</span>";
        }
        if (pageCount >= 4) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "4" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>4</span>";
        }
        if (pageCount >= 5) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "5" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>5</span>";
        }
        $(".apa-page-list").html(htmlPageNumber);
    }
    else if (currentPage == 2) {
        var htmlPageNumber = "";
        htmlPageNumber += "<span class='apa-page' id='paging-" + "1" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>1</span>";
        htmlPageNumber += "<span class='apa-page active' id='paging-" + "2" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>2</span>";
        if (pageCount >= 3) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "3" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>3</span>";
        }
        if (pageCount >= 4) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "4" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>4</span>";
        }
        if (pageCount >= 5) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + "5" + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>5</span>";
        }
        $(".apa-page-list").html(htmlPageNumber);
    }
    else if (currentPage == pageCount - 1) {
        var htmlPageNumber = "";
        if ((pageCount - 4) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 4) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 4) + "</span>";
        }
        if ((pageCount - 3) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 3) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 3) + "</span>";
        }
        if ((pageCount - 2) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 2) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 2) + "</span>";
        }
        htmlPageNumber += "<span class='apa-page active' id='paging-" + (pageCount - 1) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 1) + "</span>";
        htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount) + "</span>";
        $(".apa-page-list").html(htmlPageNumber);
    }
    else if (currentPage == pageCount) {
        var htmlPageNumber = "";
        if ((pageCount - 4) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 4) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 4) + "</span>";
        }
        if ((pageCount - 3) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 3) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 3) + "</span>";
        }
        if ((pageCount - 2) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 2) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 2) + "</span>";
        }
        if ((pageCount - 1) > 0) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (pageCount - 1) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount - 1) + "</span>";
        }
        htmlPageNumber += "<span class='apa-page active' id='paging-" + (pageCount) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (pageCount) + "</span>";
        $(".apa-page-list").html(htmlPageNumber);
    }
    else {
        var htmlPageNumber = "";
        htmlPageNumber += "<span class='apa-page ' id='paging-" + (currentPage - 2) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (currentPage - 2) + "</span>";
        htmlPageNumber += "<span class='apa-page' id='paging-" + (currentPage - 1) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (currentPage - 1) + "</span>";
        htmlPageNumber += "<span class='apa-page active' id='paging-" + (currentPage) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (currentPage) + "</span>";
        if (pageCount >= parseInt(currentPage) + 1) {
            htmlPageNumber += "<span class='apa-page ' id='paging-" + (parseInt(currentPage) + 1) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (parseInt(currentPage) + 1) + "</span>";
        }
        if (pageCount >= parseInt(currentPage) + 2) {
            htmlPageNumber += "<span class='apa-page' id='paging-" + (parseInt(currentPage) + 2) + "'' onclick='EntryPoint.ViewArticlesPaging.loadArticlePage($(this))'>" + (parseInt(currentPage) + 2) + "</span>";
        }
        $(".apa-page-list").html(htmlPageNumber);
    }

    ////show/hide the overflow indicators as appropriate
    //if ($(".apa-paging .apa-page:nth-child(2)").hasClass("paged-out")) {
    //    $(".apa-paging #previous-page-overflow").removeClass("paged-out").addClass("paged-in");
    //}
    //if ($(".apa-paging .apa-page:nth-last-child(2)").hasClass("paged-out")) {
    //    $(".apa-paging #next-page-overflow").removeClass("paged-out").addClass("paged-in");
    //}
}